import React from 'react'
import Header from "../componets/Header";
import Footer from "../componets/Footer";
import Articles from '../componets/media/Articles'
import Gallery from '../componets/media/Gallery'

const Media = () => {
    return (
        <>
            <div className='media-new-page'>
                <Header/>
                <Articles />
                <Gallery/>
                <Footer/>
            </div>
        </>
    )
}

export default Media